var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPcm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 3C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H9",
    stroke: "#067BF9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10V3.5L16 3",
    stroke: "#067BF9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12C12.3284 12 13 11.3284 13 10.5C13 9.67157 12.3284 9 11.5 9C10.6716 9 10 9.67157 10 10.5C10 11.3284 10.6716 12 11.5 12Z",
    stroke: "#067BF9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 24,
    height: 10,
    rx: 2,
    fill: "#067BF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.48 22V15.52H6.656C7.04533 15.52 7.36533 15.5947 7.616 15.744C7.86667 15.888 8.05333 16.1013 8.176 16.384C8.29867 16.6613 8.36 17 8.36 17.4C8.36 17.9013 8.27733 18.2853 8.112 18.552C7.94667 18.8133 7.72267 18.9947 7.44 19.096C7.15733 19.1973 6.84 19.248 6.488 19.248H5.912V22H4.48ZM5.912 18.248H6.392C6.568 18.248 6.70133 18.216 6.792 18.152C6.88267 18.088 6.94133 17.992 6.968 17.864C7 17.736 7.016 17.5733 7.016 17.376C7.016 17.2107 7.00267 17.0667 6.976 16.944C6.95467 16.816 6.89867 16.7147 6.808 16.64C6.71733 16.5653 6.576 16.528 6.384 16.528H5.912V18.248ZM11.3863 22.096C10.8956 22.096 10.5063 22.008 10.2183 21.832C9.93565 21.6507 9.73565 21.4 9.61831 21.08C9.50098 20.7547 9.44231 20.3733 9.44231 19.936V17.6C9.44231 17.152 9.50098 16.768 9.61831 16.448C9.73565 16.1227 9.93565 15.872 10.2183 15.696C10.5063 15.52 10.8956 15.432 11.3863 15.432C11.8663 15.432 12.2396 15.512 12.5063 15.672C12.7783 15.8267 12.9703 16.0453 13.0823 16.328C13.1943 16.6107 13.2503 16.936 13.2503 17.304V17.864H11.8503V17.216C11.8503 17.088 11.8423 16.9653 11.8263 16.848C11.8156 16.7307 11.7783 16.6347 11.7143 16.56C11.6503 16.48 11.541 16.44 11.3863 16.44C11.237 16.44 11.125 16.48 11.0503 16.56C10.981 16.64 10.9356 16.7413 10.9143 16.864C10.8983 16.9813 10.8903 17.1067 10.8903 17.24V20.288C10.8903 20.432 10.901 20.5653 10.9223 20.688C10.949 20.8053 10.997 20.9013 11.0663 20.976C11.141 21.0453 11.2476 21.08 11.3863 21.08C11.5356 21.08 11.6423 21.0427 11.7063 20.968C11.7703 20.888 11.8103 20.7867 11.8263 20.664C11.8423 20.5413 11.8503 20.416 11.8503 20.288V19.608H13.2503V20.168C13.2503 20.536 13.1943 20.8667 13.0823 21.16C12.9756 21.448 12.7863 21.6773 12.5143 21.848C12.2476 22.0133 11.8716 22.096 11.3863 22.096ZM14.4941 22L14.6061 15.52H16.1421L16.8541 19.288L17.6221 15.52H19.1021L19.2141 22H18.1981L18.0781 17.688L17.3261 22H16.4221L15.6221 17.656L15.5261 22H14.4941Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcm);
export default __webpack_public_path__ + "static/media/pcm.ae6eb118791165d0d2f39993d08f689b.svg";
export { ForwardRef as ReactComponent };